import axios from "axios"

export const Dn6Service = Object.freeze({
  ClearDn7SiteCache: function () {
    return axios.get("/WebServices/CacheWebservice.asmx/ClearDn7PagesCache")
  }
})
